// Every live Bloomreach origin — undocumented by Bloomreach; source of truth here.
const BLOOMREACH_ORIGINS = [
  'https://ap1.eng.bloomreach.com',
  'https://ca1.eng.bloomreach.com',
  'https://eu2.eng.bloomreach.com',
  'https://eu3.eng.bloomreach.com',
  'https://uk1.eng.bloomreach.com',
  'https://uk2.eng.bloomreach.com',
  'https://us2.eng.bloomreach.com',
  'https://us3.eng.bloomreach.com',
  'https://app.exponea.com',
  'https://app.eu1.exponea.com',
  'https://app.us1.exponea.com',
  'https://app.uk.exponea.com',
  'https://app-cis.exponea.com',
  'https://cloud.exponea.com',
  'https://cloud.infinario.com',
  'https://engagement.bloomreach.com',
  'https://demoapp.exponea.com',
  'https://demoapp.bloomreach.com',
];

const LOCAL_PARENT_ORIGINS = ['http://localhost:5174', 'http://127.0.0.1:5174'];

const extraOrigins = () =>
  (process.env.REACT_APP_BLOOMREACH_EXTRA_ORIGINS || '')
    .split(',')
    .map((origin) => origin.trim())
    .filter(Boolean);

export const isLocalHost = () =>
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export function allowedOrigins() {
  const origins = [...BLOOMREACH_ORIGINS, ...extraOrigins()];
  if (isLocalHost()) origins.push(...LOCAL_PARENT_ORIGINS);
  return origins;
}

// Bloomreach serves its app from subdomains of these, including customers' dedicated instances
// (e.g. Landmark's https://lmd.bloomreach.co). https on the default port only.
const BLOOMREACH_DOMAINS = ['bloomreach.com', 'bloomreach.co', 'exponea.com'];

// Exact allow-list first, then any https host on a Bloomreach domain. url.origin !== origin
// rejects anything that isn't a bare origin (path, trailing slash, credentials, odd casing).
export function isAllowedOrigin(origin) {
  if (allowedOrigins().includes(origin)) return true;
  let url;
  try {
    url = new URL(origin);
  } catch {
    return false;
  }
  if (url.origin !== origin || url.protocol !== 'https:' || url.port !== '') return false;
  const host = url.hostname;
  return BLOOMREACH_DOMAINS.some((domain) => host === domain || host.endsWith(`.${domain}`));
}
